<div appLocalizationPopupDirective [localizationCode]="'SearchBarPlaceholder'" class="search" role="search" aria-label="Site search" data-cy="header-search">
    <div class="button-container">
        <button *ngIf="searchValue" type="button" class="search-icon-button" aria-label="Clear search" data-cy="header-search-clear" (click)="clearSearch()">
            <mat-icon class="material-icons-outlined search-icon" aria-hidden="true">close</mat-icon>
        </button>
        <mat-icon class="material-icons-outlined search-icon" aria-hidden="true">search</mat-icon>
    </div>
    <label class="sr-only" for="header-site-search-input">Search site</label>
    <input
        id="header-site-search-input"
        type="search"
        role="combobox"
        autocomplete="off"
        class="search-input"
        data-cy="header-search-input"
        [placeholder]="translate.instant('SearchBarPlaceholder')"
        [attr.aria-label]="translate.instant('SearchBarPlaceholder')"
        [attr.aria-controls]="'header-site-search-results'"
        [attr.aria-expanded]="!!searchValue"
        [attr.aria-activedescendant]="activeResultId"
        aria-haspopup="listbox"
        [(ngModel)]="searchValue"
        (input)="onSearchInput()"
        (keydown)="onKeydown($event)"
    >
</div>

<div *ngIf="searchValue && !isLoading && results" class="sr-only" aria-live="polite">
    {{ totalResultCount }} search result{{ totalResultCount === 1 ? '' : 's' }} found.
</div>

<div class="search-results" *ngIf="searchValue" id="header-site-search-results" role="region" aria-label="Search results" data-cy="header-search-results">
    <ng-template #loading>
        <div
            class="result"
            aria-hidden="true">
            <div class="thumbnail">
                <ngx-skeleton-loader
                    count="1"
                    appearance="circle"
                    [theme]="{
                    'height.px': 50,
                    'width.px': 50
                    }">
                </ngx-skeleton-loader>
            </div>
            <div class="text">
                <div class="loader">
                    <ngx-skeleton-loader
                        count="1"
                        [theme]="{
                        'height.px': 20,
                        'width.px': 200
                        }"
                    ></ngx-skeleton-loader>

                    <ngx-skeleton-loader
                        count="1"
                        [theme]="{
                        'height.px': 15,
                        'width.px': 175
                        }"
                    ></ngx-skeleton-loader>
                </div>
            </div>
        </div>
    </ng-template>

    <div *ngIf="!isLoading && results; else loading" role="listbox" [attr.aria-label]="'Search results'">
        <ng-container>
            <ng-container *ngIf="results.employees != null && results.employees.length > 0">
                <div class="results-section-title" id="employees-search-results-title" appLocalizationPopupDirective [localizationCode]="'Employees'" data-cy="header-search-results-employees-title">
                    {{ 'Employees' | translate: {Default: "Employees"} }}
                </div>
                <a
                    class="result employee"
                    *ngFor="let employee of results.employees; let i = index"
                    [id]="'search-result-employee-' + i"
                    [routerLink]="[routes.TALENT_TRACK + routes.EDIT + '/' + employee.id + routes.EMPLOYEE_DETAILS]"
                    [attr.data-cy]="'header-search-result-employee-' + employee.id"
                    [attr.aria-label]="'Open employee profile for ' + employee.firstName + ' ' + employee.lastName"
                    [attr.aria-selected]="activeResultId === 'search-result-employee-' + i"
                    role="option"
                    aria-describedby="employees-search-results-title"
                    (keydown)="onResultKeydown($event, $any($event.currentTarget))">
                    <div class="thumbnail k-mr-4">
                        <app-employee-image [profilePhoto]="employee.profilePhoto" [width]="50" [height]="50" [round]="true"></app-employee-image>
                    </div>
                    <div class="text">
                        <div class="name">{{employee.firstName}} {{employee.lastName}}</div>
                    </div>
                </a>
                <div class="load-more">
                    <ng-container *ngIf="loadingMore === false; else showLoadingMore">
                        <button mat-stroked-button setColor="primaryColour" color="primary" data-cy="header-search-load-more-employees" appPreventDoubleClick (throttledClick)="loadMore()" appLocalizationPopupDirective [localizationCode]="'LoadMore'">
                            {{ 'LoadMore' | translate: {Default: "Load More"} }}
                        </button>
                    </ng-container>

                    <ng-template #showLoadingMore>
                        <div
                            class="result"
                            aria-hidden="true">
                            <div class="thumbnail">
                                <ngx-skeleton-loader
                                    count="1"
                                    appearance="circle"
                                    [theme]="{
                                    'height.px': 50,
                                    'width.px': 50
                                    }">
                                </ngx-skeleton-loader>
                            </div>
                            <div class="text">
                                <div class="loader">
                                    <ngx-skeleton-loader
                                        count="1"
                                        [theme]="{
                                        'height.px': 20,
                                        'width.px': 200
                                        }"
                                    ></ngx-skeleton-loader>

                                    <ngx-skeleton-loader
                                        count="1"
                                        [theme]="{
                                        'height.px': 15,
                                        'width.px': 175
                                        }"
                                    ></ngx-skeleton-loader>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>
            </ng-container>
        </ng-container>

        <ng-container>
            <ng-container *ngIf="results.positions != null && results.positions.length > 0">
                <div class="results-container">
                    <div class="results-section-title" id="positions-search-results-title" appLocalizationPopupDirective [localizationCode]="'Positions'" data-cy="header-search-results-positions-title">
                        {{ 'Positions' | translate: {Default: "Positions"} }}
                    </div>
                    <a
                        class="result form"
                        *ngFor="let position of results.positions; let i = index"
                        [id]="'search-result-position-' + i"
                        [routerLink]="[routes.SITE_SETTINGS + routes.POSITIONS + routes.EDITOR + '/' + position.id]"
                        [attr.data-cy]="'header-search-result-position-' + position.id"
                        [attr.aria-label]="'Open position ' + position.name"
                        [attr.aria-selected]="activeResultId === 'search-result-position-' + i"
                        role="option"
                        aria-describedby="positions-search-results-title"
                        (keydown)="onResultKeydown($event, $any($event.currentTarget))"
                    >
                        <div class="thumbnail k-mr-4">
                            <mat-icon class="material-icons-outlined" aria-hidden="true">account_box</mat-icon>
                        </div>
                        <div class="text">
                            <h5 class="name">{{position.name}}</h5>
                        </div>
                    </a>
                    <div class="load-more">
                        <ng-container *ngIf="loadingMore === false; else showLoadingMore">
                            <button mat-stroked-button setColor="primaryColour" color="primary" data-cy="header-search-load-more-positions" appPreventDoubleClick (throttledClick)="loadMore()" appLocalizationPopupDirective [localizationCode]="'LoadMore'">
                                {{ 'LoadMore' | translate: {Default: "Load More"} }}
                            </button>
                        </ng-container>

                        <ng-template #showLoadingMore>
                            <div
                                class="result"
                                aria-hidden="true">
                                <div class="thumbnail">
                                    <ngx-skeleton-loader
                                        count="1"
                                        appearance="circle"
                                        [theme]="{
                                        'height.px': 50,
                                        'width.px': 50
                                        }">
                                    </ngx-skeleton-loader>
                                </div>
                                <div class="text">
                                    <div class="loader">
                                        <ngx-skeleton-loader
                                            count="1"
                                            [theme]="{
                                            'height.px': 20,
                                            'width.px': 200
                                            }"
                                        ></ngx-skeleton-loader>

                                        <ngx-skeleton-loader
                                            count="1"
                                            [theme]="{
                                            'height.px': 15,
                                            'width.px': 175
                                            }"
                                        ></ngx-skeleton-loader>
                                    </div>
                                </div>
                            </div>
                        </ng-template>
                    </div>
                </div>
            </ng-container>
        </ng-container>

       <ng-container *ngIf="hasNoResults">
            <div class="result" role="status" aria-live="polite" data-cy="header-search-no-results">
                <div class="thumbnail">
                    <mat-icon class="material-icons-outlined" aria-hidden="true">manage_search</mat-icon>
                </div>
                <div class="text">
                    <h5 class="name" appLocalizationPopupDirective [localizationCode]="'NothingFoundFor'">{{ 'NothingFoundFor' | translate: {Default: "Nothing found for"} }} '{{searchValue}}'</h5>
                </div>
            </div>
        </ng-container>
    </div>
</div>
